import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from 'react';
import {
  useGlobalState,
  RealtimeGlobalStateProvider,
} from '../../../state/RealtimeGlobalContextProvider';
import { useLocation } from 'react-router-dom';
import {
  FaHourglassEnd,
  FaPause,
  FaPlay,
  FaPrint,
  FaShare,
  FaSpinner,
} from 'react-icons/fa6';
import Card from './components/card';
import { PiInfo } from 'react-icons/pi';
import { TfiLayers } from 'react-icons/tfi';
import RatingBar from './components/rating-bar';
import VideoModal from './components/video-full-screen';

import { useSearchParams } from 'react-router-dom';
import SelectView from './components/select-view';
import {
  MediaType,
  mediaTypeMap,
  DISPLAY_DIMENSIONS,
  VIDEO_DIMENSIONS,
} from './constants';
import { useWebRTC } from './hooks/useWebRTC';
// import { PLANES_CONFIGS } from './config/planes.config';
import { buildPlanes } from './utils/planeBuilder';
import VideoDisplay from './components/video-display';

import LastDetectedPlanes from './components/last-detected-planes';
import { PLANES_CONFIGS } from './config/planes.config';
import DebugSegmentations from './components/debug-segmentations';
// import GenerateReportModal from './components/report';
import { messageI18n } from '../../../helpers/i18n/toastI18n';
import { AiOutlineLoading } from 'react-icons/ai';
import ReportModal from './components/report';
import { useVideoProcessing } from '../../Components/hooks/useVideoProcessing';

import { useNavigate } from 'react-router-dom';
import { useGetGlobalReportByStudyId } from '../../../helpers/api/reports/reports';
import {
  useSaveViews,
  useUpdatePixelSpacing,
} from '../../../helpers/api/realtime/realtime';
import { Icon } from '@ohif/ui';
import { MdOutlineDashboard } from 'react-icons/md';
import { IoIosFlash } from 'react-icons/io';
import { apiClient } from '../../../helpers/apiHelper';
import StepperFeedRealtime from '../../Components/StepperFeedRealtime';
import { useHtmlDataTheme } from '../../../services/useHtmlDataTheme';
import { Button } from '../../ComponnentsUI/common/Button';


declare const ImageCapture: typeof globalThis.ImageCapture;

const RealTimeInferencingV3: React.FC = () => {
  const user = {};
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const uid = searchParams.get('StudyInstanceUIDs');
  const serieUid = searchParams.get('SeriesInstanceUIDs');
  const { isLoading, data, error } = uid
    ? useGetGlobalReportByStudyId(uid, ['globalReportData'])
    : { isLoading: false, data: null, error: null };
  const [sessionEnded, setSessionEnded] = useState(false);
  const navigate = useNavigate();

  const configuration: RTCConfiguration = {
    iceServers: [
      {
        urls: 'stun:stun.l.google.com:19302',
      },
    ],
  };
  const optimizeVideoTrack = async (track: MediaStreamTrack) => {
    if (pcRef.current && track.kind === 'video') {
      const transceiver = pcRef.current.addTransceiver(track, {
        direction: 'sendrecv',
        sendEncodings: [
          {
            maxBitrate: 900000,
            maxFramerate: 30,
            scaleResolutionDownBy: 1,
          },
        ],
      });

      try {
        const capabilities = RTCRtpSender.getCapabilities('video');
        if (capabilities) {
          const vp8Codec = capabilities.codecs.find(
            (codec) => codec.mimeType.toLowerCase() === 'video/vp8'
          );
          if (vp8Codec) {
            await transceiver.setCodecPreferences([vp8Codec]);
          }
        }
      } catch (error) {
        console.warn('Failed to set codec preferences:', error);
      }
    }
  };

  const {
    webrtcVideoRef,
    isInferencing,
    setIsInferencing,
    videoMaskStream,
    initializeConnection,
    closeConnection,
    setVideoMaskStream,
    createPeerConnection,
    pcRef,
    dataChannelRef,
    negotiate,
  } = useWebRTC({
    api: process.env.BACKEND_URL,
    videoTransform: 'rotate',
    clientId: user?.profile?.sub,
  });
  const processedVideoRef = useRef<HTMLCanvasElement>(null);
  const [intervalId, setIntervalId] = useState<NodeJS.Timeout | null>(null);

  const [isPixelSpacingCalcul, setIsPixelSpacingCalcul] = useState(false);
  const { globalState, setGlobalState } = useGlobalState();
  const {
    videoStream,
    videoRef,
    processingCanvasRef,
    processedStreamRef,
    isVideoLoading,
    createCroppedStream,
    startVideoStream,
    stopVideoStream,
    setIsVideoLoading,
    setVideoStream,
  } = useVideoProcessing(globalState.deviceId);
  // const planes: Plane[] = buildPlanes(PLANES_CONFIGS, globalState);
  const theme = useHtmlDataTheme();

  const planes = useMemo(() => {
    return buildPlanes(PLANES_CONFIGS, globalState, theme);
  }, [globalState, theme]);
  const [isModalOpen, setModalOpen] = useState(false);
  const [isChecked, setIsChecked] = useState(false);
  const [bool, setBool] = useState(true);

  const [deviceMediaType, setDeviceMediaType] = useState(
    MediaType.DISPLAY_MEDIA
  );

  const [useDataChannel] = useState(true);
  const [selectedPlansModal, setSelectedPlansModal] = useState('');
  const [selectedPlansTag, setSelectedPlansTag] = useState('');
  const [isOpen, setIsOpen] = useState(false);
  const [currentStep, setCurrentStep] = useState(1);
  const [showPrerequisitesModal, setShowPrerequisitesModal] = useState(false);
  const [isInitialSetupComplete, setIsInitialSetupComplete] = useState(false);
  const [showDeviceModal, setShowDeviceModal] = useState(true);
  const [hasStarted, setHasStarted] = useState(false);
  const canvasRef = useRef<HTMLCanvasElement>(null);
  const modalCanvasVideoRef = useRef<HTMLCanvasElement>(null);
  const [isVideoBigDisplayOpen, setIsVideoBigDisplayOpen] = useState(false);
  const [showPatientModal, setShowPatientModal] = useState(false);

  const [selectedRow, setSelectedRow] = useState<{
    row_id: any;
    patient: any;
  } | null>(null);
  const handlePatientSelection = () => {
    if (selectedRow?.patient) {
      setGlobalState((prevState) => ({
        ...prevState,
        patient: selectedRow.patient,
      }));
    }
    setShowPatientModal(false);
  };
  const onSuccessSaveViews = (response, data) => {
    console.log('response onSuccessSaveViews', response);
    updateGlobalStateWithFrameIds(
      globalState,
      response?.data?.result.report.data.frame_view_mapping
    );
    setIsPixelSpacingCalcul(false);
    setSessionEnded(true);
  };
  const onErrorSaveViews = (error, data) => {
    setIsPixelSpacingCalcul(false);
    setSessionEnded(true);
  };
  const onSuccessUpdatePixel = (response, data) => { };
  const onErrorUpdatePixel = (error, data) => { };
  const { mutate: updatePixelSpacing, isPending: updatePixelSpacingLoading } =
    useUpdatePixelSpacing(onSuccessUpdatePixel, onErrorUpdatePixel);
  const { mutate: saveViews, isPending: saveViewsLoading } = useSaveViews(
    onSuccessSaveViews,
    onErrorSaveViews
  );

  console.log('isInferencing :::', isInferencing, videoRef);
  const realtimeExamDuration = 1000;

  const MACHINE_CROP_REGIONS = useMemo(
    () => ({
      GEVE6: globalState?.pixelSpacingConfig?.crop_box, // Now it updates when globalState changes
      // Add other machines here:
      // machine_name: [left, upper, right, lower]
    }),
    [globalState?.pixelSpacingConfig?.crop_box]
  ); // Dependency array ensures it updates

  interface CropRegion {
    width: number;
    height: number;
    x: number;
    y: number;
  }

  const covertToFrontendCropping = (cropBox: number[]): CropRegion => {
    const [left, upper, right, lower] = cropBox;
    return {
      width: right - left,
      height: lower - upper,
      x: left,
      y: upper,
    };
  };
  const videoWidth = videoRef?.current?.videoWidth;
  const videoHeight = videoRef?.current?.videoHeight;
  const cropBox =
    globalState?.machineConfig &&
      (globalState.machineConfig.crop_height != null ||
        globalState.machineConfig.crop_width != null ||
        globalState.machineConfig.crop_x != null ||
        globalState.machineConfig.crop_y != null)
      ? [
        globalState.machineConfig.crop_height ?? 0,
        globalState.machineConfig.crop_width ?? 0,
        globalState.machineConfig.crop_x ?? 0,
        globalState.machineConfig.crop_y ?? 0,
      ]
      : [0, 0, videoWidth ?? 0, videoHeight ?? 0];
  console.log('cropBox :::', cropBox);
  let CROP_REGION = covertToFrontendCropping(cropBox);
  // let CROP_REGION = covertToFrontendCropping(
  //   [0, 0, videoWidth, videoHeight]
  // );
  // State to hold the cropped stream
  console.log('CROP_REGION12 :::', CROP_REGION);
  const [croppedStream, setCroppedStream] = useState<MediaStream | null>(null);

  const captureFrame = useCallback(() => {
    const video = videoRef.current;
    const canvas = canvasRef.current;
    const context = canvas?.getContext('2d');

    if (!video || !context || !canvas || !globalState?.wsRef.current) return;

    const videoWidth = video.videoWidth;
    const videoHeight = video.videoHeight;

    // Fallback if video metadata not loaded yet
    if (!videoWidth || !videoHeight) return;

    let cropX = 0;
    let cropY = 0;
    let cropWidth = videoWidth;
    let cropHeight = videoHeight;

    if (globalState?.machineConfig) {
      const machineConfig = globalState.machineConfig;

      if (machineConfig.crop_x !== undefined && machineConfig.crop_x !== null) {
        cropX = Math.max(0, Math.min(videoWidth, machineConfig.crop_x));
      }
      if (machineConfig.crop_y !== undefined && machineConfig.crop_y !== null) {
        cropY = Math.max(0, Math.min(videoHeight, machineConfig.crop_y));
      }
      if (
        machineConfig.crop_width !== undefined &&
        machineConfig.crop_width !== null
      ) {
        cropWidth = Math.max(
          0,
          Math.min(videoWidth - cropX, machineConfig.crop_width)
        );
      }
      if (
        machineConfig.crop_height !== undefined &&
        machineConfig.crop_height !== null
      ) {
        cropHeight = Math.max(
          0,
          Math.min(videoHeight - cropY, machineConfig.crop_height)
        );
      }
    }

    // Optionally: skip drawing if crop is invalid
    if (cropWidth === 0 || cropHeight === 0) return;

    // Draw the cropped frame to canvas
    context.drawImage(
      video,
      cropX,
      cropY,
      cropWidth,
      cropHeight,
      0,
      0,
      VIDEO_DIMENSIONS.width,
      VIDEO_DIMENSIONS.height
    );

    console.log('Captured frame with machine config cropping:', {
      cropX,
      cropY,
      cropWidth,
      cropHeight,
      videoWidth,
      videoHeight,
      machineConfig: globalState?.machineConfig,
    });

    // Check if WebSocket is connected before sending frame
    if (!globalState?.wsRef.current?.isConnected()) {
      // Silently skip - WebSocket not ready yet
      return;
    }

    const frameData = canvas.toDataURL('image/jpeg', 0.8);
    const sent = globalState.wsRef.current.sendFrame(frameData, '1', globalState.sessionId);
    if (!sent) {
      // Frame not sent (WebSocket not ready) - this is expected during connection
      return;
    }
  }, [globalState?.machineConfig, globalState?.isConnected]);

  // Effect to create the cropped stream and handle WebRTC setup
  const isVideoBigDisplayOpenRef = useRef(isVideoBigDisplayOpen);
  let lastFrameTime = Date.now();
  const frameTimeout = 5000;
  useEffect(() => {
    isVideoBigDisplayOpenRef.current = isVideoBigDisplayOpen;
  }, [isVideoBigDisplayOpen]);
  // Initialize sessionId when exam starts
  useEffect(() => {
    if (globalState.isStart && !globalState.sessionId) {
      // Generate a unique session ID
      const randomSessionId =
        Math.random().toString(36).substring(2, 15) +
        Math.random().toString(36).substring(2, 15) +
        Math.random().toString(36).substring(2, 15) +
        Date.now().toString(36);

      console.log('🎯 Initializing sessionId for realtime exam:', randomSessionId);
      setGlobalState((prevState) => ({
        ...prevState,
        sessionId: randomSessionId,
      }));
    }
  }, [globalState.isStart, globalState.sessionId]);

  // Start frame capture interval when WebSocket is connected and exam is started
  useEffect(() => {
    // Cleanup any existing interval first
    if (intervalId) {
      clearInterval(intervalId);
      setIntervalId(null);
    }

    if (
      globalState?.approach === 'newWS' &&
      globalState?.isConnected &&
      globalState?.isStart &&
      !globalState.isVideoFrozen &&
      globalState?.wsRef.current?.isConnected()
    ) {
      // WebSocket is connected, start capturing frames
      const interval = setInterval(captureFrame, 1000);
      setIntervalId(interval);
      console.log('✅ Started frame capture interval - WebSocket connected');

      return () => {
        clearInterval(interval);
        setIntervalId(null);
      };
    }
  }, [
    globalState?.isConnected,
    globalState?.isStart,
    globalState?.isVideoFrozen,
    globalState?.approach,
    captureFrame,
  ]);

  useEffect(() => {
    let interval123: NodeJS.Timeout | null = null; // ABdou added this to fix temporary bug found by rabi, to be adjusted later as u wish
    const setupWebRTC = async () => {
      console.log(bool, 'bool value in useEffect', videoStream);
      if (!globalState.isVideoFrozen && globalState?.isStart) {
        // Create cropped stream only once and reuse it
        const newCroppedStream = createCroppedStream(videoStream, CROP_REGION);
        setCroppedStream(newCroppedStream);
        console.log(' test is inf :::');
        setIsInferencing(true);

        if (globalState?.approach === 'newWS') {
          // Interval will be started by separate useEffect when WebSocket is connected
          // See useEffect below that watches isConnected

          globalState?.wsRef.current.setOnFrameCallback(
            (frameData: string) => {
              const img = new Image();
              img.onload = () => {
                const ctx = processedVideoRef.current?.getContext('2d');
                if (ctx && processedVideoRef.current) {
                  ctx.drawImage(
                    img,
                    0,
                    0,
                    processedVideoRef.current.width,
                    processedVideoRef.current.height
                  );
                }
                if (isVideoBigDisplayOpenRef.current) {
                  const ctxmodal =
                    modalCanvasVideoRef.current?.getContext('2d');
                  if (ctxmodal && modalCanvasVideoRef.current) {
                    ctxmodal.drawImage(
                      img,
                      0,
                      0,
                      modalCanvasVideoRef.current.width,
                      modalCanvasVideoRef.current.height
                    );
                  }
                }
              };
              img.src = JSON.parse(frameData)?.data;
              const data = JSON.parse(frameData)?.data;

              setGlobalState((prevState) => ({
                ...prevState,
                receivedData: JSON.parse(frameData)?.data,
                viewList: [
                  ...new Set([...prevState.viewList, ...(data?.views || [])]),
                ],
              }));
            },
            [modalCanvasVideoRef]
          );

          setIsInferencing(true);
          interval123 = setInterval(() => {
            if (Date.now() - lastFrameTime > frameTimeout) {
              console.log('Stream stopped or no data received for 5 seconds.');
              // You can now handle the "stream stopped" condition, e.g., show a message or stop video processing.
            }
          }, 1000);
        }
      } else {
        // Cleanup
        globalState?.wsRef.current.setOnFrameCallback(null);
        if (processedStreamRef.current) {
          processedStreamRef.current
            .getTracks()
            .forEach((track) => track.stop());
          processedStreamRef.current = null;
        }

        if (dataChannelRef.current) {
          dataChannelRef.current.close();
        }
        if (pcRef.current) {
          pcRef.current.close();
          pcRef.current = null;
        }
        if (videoStream && videoRef.current) {
          console.log('Setting video source object :');
          videoRef.current.srcObject = videoStream;
        }
        setIsInferencing(false);

        if (intervalId) {
          clearInterval(intervalId); // Cleanup interval
        }
      }
    };

    setupWebRTC();

    return () => {
      // Cleanup when component unmounts or dependencies change
      if (processedStreamRef.current) {
        processedStreamRef.current.getTracks().forEach((track) => track.stop());
      }
      if (pcRef.current) {
        pcRef.current.close();
        pcRef.current = null;
      }
      if (intervalId) {
        clearInterval(intervalId); // Clear interval on cleanup
      }
      if (interval123) {
        clearInterval(interval123);
      }
    };
  }, [
    globalState.isVideoFrozen,
    globalState?.isStart,
    videoStream,
    bool,
    globalState?.machineType,
  ]);

  // Make sure to clean up the cropped stream
  useEffect(() => {
    return () => {
      croppedStream?.getTracks().forEach((track) => track.stop()); // Cleanup
    };
  }, [croppedStream]);

  const API = process.env.BACKEND_URL?.replace(/\/api\/v1$/, '');

  useEffect(() => {
    // if (globalState?.isStart) {
    //   console.log(
    //     'Starting video stream with deviceId:',
    //     globalState.isStart,
    //     'and optionValueDevice:',
    //     globalState.optionValueDevice,globalState.deviceId
    //   );
    //   startVideoStream(globalState.deviceId, globalState.optionValueDevice);
    // }

    return () => {
      stopVideoStream();
    };
  }, [globalState?.isStart, bool]);

  const mediaTypeSwitcher = () => {
    mediaTypeMap.forEach((mediaType, option) => {
      if (globalState.optionValueDevice === option) {
        setDeviceMediaType(mediaType);
      }
    });
  };

  useEffect(() => {
    if (isInferencing) {
      setIsVideoLoading(true); // Start loading
      const timeout = setTimeout(() => setIsVideoLoading(false), 1200); // Simulate loading time
      return () => clearTimeout(timeout); // Cleanup timeout
    } else {
      setIsVideoLoading(false);
    }
  }, [isInferencing]);

  const handleChange = (e) => {
    handleVideoClick();

    // toggleVideoFreeze();
  };
  const firstDetectedPlane = globalState?.lastDetectedPlane
    ?.split(',')?.[0]
    ?.trim();

  const predictionHistory =
    globalState?.planes[firstDetectedPlane]?.predictionHistory
      ?.slice(0, 4) || [];

  // Calculate placeholders for skeleton
  const skeletonCount = Math.max(4 - predictionHistory.length, 0);
  const [divHeight, setDivHeight] = useState('60%');

  const calculateHeight = () => {
    // Example: Subtracting some pixels or using available height
    const availableHeight = window.innerHeight;
    const calculatedHeight = availableHeight; // 60% of the viewport height
    setDivHeight(`${calculatedHeight}px`);
  };

  useEffect(() => {
    setGlobalState((prevState) => ({
      ...prevState,
      doctorName: user?.profile?.name,
    }));
    calculateHeight(); // Initial calculation
    window.addEventListener('resize', calculateHeight); // Update on resize

    return () => {
      window.removeEventListener('resize', calculateHeight); // Cleanup
    };
  }, []);

  const countPlanesWithFrame = (planes) => {
    let count = 0;

    for (const planeKey in planes) {
      if (planes[planeKey]?.frame) {
        count++;
      }
    }

    return count;
  };

  const planesWithFrameCount = countPlanesWithFrame(globalState.planes);
  const isButtonDisabled =
    !Object.keys(globalState?.planes).some(
      (tag) => globalState?.planes[tag]?.selectedViewData
    ) || globalState?.patient?.patient_name == null;
  const handleOpenReport = () => {
    if (globalState?.patient?.patient_name == null) {
      messageI18n.warning('report.choosePatient');
    }
    if (
      !Object.keys(globalState?.planes).some(
        (tag) => globalState?.planes[tag]?.selectedViewData
      )
    ) {
      messageI18n.warning('report.chooseView');
    }
    if (!isButtonDisabled) {
      setGlobalState((prevState) => ({
        ...prevState,
        reportModalOpened: !globalState.reportModalOpened,
      }));
    }
  };

  const handlePauseResume = () => {
    setIsChecked(!isChecked);
    setGlobalState((prevState) => ({
      ...prevState,
      isVideoFrozen: !prevState.isVideoFrozen,
    }));
  };
  // Start the video stream if not already started

  const handleVideoClick = () => {
    setIsChecked(!isChecked);
    setGlobalState((prevState) => ({
      ...prevState,
      isVideoFrozen: !prevState.isVideoFrozen,
    }));
  };

  const [examDuration, setExamDuration] = useState(realtimeExamDuration);
  const [isTimerRunning, setIsTimerRunning] = useState(false);

  const formatTime = (seconds: number) => {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    return `${minutes}:${remainingSeconds.toString().padStart(2, '0')}`;
  };

  useEffect(() => {
    let timer: NodeJS.Timeout;

    // Only start timer if device and machine are selected, video is not frozen, and exam isn't ended
    const isSetupComplete = globalState.deviceId && globalState?.machineConfig;

    if (
      isSetupComplete &&
      !globalState.isVideoFrozen &&
      !globalState.isExamEnded &&
      examDuration > 0
    ) {
      setIsTimerRunning(true);
      timer = setInterval(() => {
        setExamDuration((prev) => {
          if (prev <= 1) {
            // Time's up - end the examination
            setGlobalState((prevState) => ({
              ...prevState,
              isExamEnded: true,
              isVideoFrozen: true,
            }));
            setIsTimerRunning(false);
            return 0;
          }
          return prev - 1;
        });
      }, 1000);
    } else {
      setIsTimerRunning(false);
    }

    return () => {
      if (timer) clearInterval(timer);
    };
  }, [
    globalState.isVideoFrozen,
    globalState.isExamEnded,
    examDuration,
    globalState.deviceId,
    globalState.selectedItem,
  ]);
  const sendAllPredictionsToBackend = async (planes, patientId) => {
    try {
      const sessionId = globalState.sessionId;
      console.log('[sendAllPredictionsToBackend] Sending with session_id:', sessionId);

      const payload = {
        patient_id: patientId,
        StudyInstanceUID: uid,
        SeriesInstanceUID: serieUid,
        session_id: sessionId, // Include session_id for performance tracking
        views: Object.entries(planes).map(([viewName, viewData]) => ({
          view: viewName,
          prediction_history: viewData.predictionHistory.map(
            ({
              frameIndex,
              measurements,
              pixelSpacing,
              quality_criteria,
              score,
              structuresToDraw,
              imageRef, // ✅ include imageRef
            }) => ({
              frameIndex,
              imageRef, // ✅ include here
              measurements,
              pixelSpacing,
              quality_criteria,
              score,
              structuresToDraw,
            })
          ),
        })),
      };

      // const response = await api.post('/create-realtime-dicom', payload);
      const response = await saveViews(payload);

      // return response.result.report.data.frame_view_mapping;
    } catch (error) {
      console.error('[sendAllPredictionsToBackend] API error:', error);
    }
  };

  const planesToProcess = [
    'VIEW__FetalAbdominalStandardPlane',
    'VIEW__Transthalamic',
    'VIEW__Femoral',
  ]; // Only process these planes
  useEffect(() => {
    const processPlanes = async () => {
      try {
        console.log('[processPlanes] Start processing planes');
        setIsPixelSpacingCalcul(true);
        const updatedPlanes = { ...globalState.planes };

        // Create an array of promises to process planes in parallel

        console.log(
          '[processPlanes] All planes processed, updating global state'
        );
        setGlobalState((prevState) => ({
          ...prevState,
          planes: updatedPlanes,
        }));
        const result = await sendAllPredictionsToBackend(
          globalState?.planes,
          globalState?.patient.id
        );
        // console.log('resultR ::', result);
        // updateGlobalStateWithFrameIds(globalState, result);
        // setIsPixelSpacingCalcul(false);
        console.log('[processPlanes] Done');
      } catch (error) {
        console.error('[processPlanes] Error in processing planes:', error);
        setIsPixelSpacingCalcul(false);
      }
    };

    if (globalState.isExamEnded) {
      processPlanes();
    }
  }, [globalState.isExamEnded]);
  function updateGlobalStateWithFrameIds(currentState, response) {
    // Get all the view keys from the response
    console.log('Response updateGlobalStateWithFrameIds:', response);
    const viewKeys = Object.keys(response);

    // Use reduce to build the new `planes` object
    const updatedPlanes = Object.keys(currentState.planes).reduce(
      (acc, viewKey) => {
        // Check if this viewKey has updates in the response AND exists in the current state
        if (
          response[viewKey] &&
          currentState.planes[viewKey].predictionHistory
        ) {
          // Create the lookup map (same as before)
          const frameIdMap = response[viewKey].reduce((map, frameInfo) => {
            map[frameInfo.original_frame_number] = frameInfo.frame_id;
            return map;
          }, {});

          // Create a new, updated predictionHistory array
          const newPredictionHistory = currentState.planes[
            viewKey
          ].predictionHistory.map((prediction) => ({
            ...prediction,
            frame_id: frameIdMap[prediction.frameIndex] || null, // Add the ID, or null if not found
          }));

          // Create a new view object with the new predictionHistory
          acc[viewKey] = {
            ...currentState.planes[viewKey], // Copy other properties like 'frame', 'imgReport'
            predictionHistory: newPredictionHistory, // Overwrite with the updated array
          };
        } else {
          // If no updates for this view, just copy the old one over
          acc[viewKey] = currentState.planes[viewKey];
        }
        return acc;
      },
      {}
    );
    setGlobalState((prevState) => ({
      ...prevState,
      planes: updatedPlanes,
    }));
    // Return a new globalState object with the newly created planes object
    return {
      ...currentState,
      planes: updatedPlanes,
    };
  }
  // Clean states on page load (mount)
  useEffect(() => {
    setGlobalState((prevState) => ({
      ...prevState,
      isExamEnded: false,
      isVideoFrozen: true,
      lastDetectedPlane: '',
      planes: {},
      patient: null,
      viewList: [],
      viewDetectionOrder: [],
      reportModalOpened: false,
      receivedData: null,
      deviceId: '',
      selectedItem: 'Select your machine',
      pixelSpacingConfig: {},
      configMachine: {},
      isStart: false,
      inputDevices: [],
      selectedItemsMultidrop: [],
      optionValueDevice: 'USB',
      // add any other state keys you want to reset here
    }));
    setBool(true);
    setVideoMaskStream && setVideoMaskStream(null);
    setIsChecked(false);
    setSelectedPlansModal('');
    setSelectedPlansTag('');
    setShowDeviceModal(true);
    setIsInitialSetupComplete(false);
    setIsVideoBigDisplayOpen(false);
    setShowPatientModal(false);
    setSelectedRow(null);
    setExamDuration(realtimeExamDuration);
    setIsTimerRunning(false);
    // ...add any other local state resets if needed
    console.log('Global state reset on page load');
  }, []);

  useEffect(() => {
    const handleBeforeUnload = (event: BeforeUnloadEvent) => {
      console.log('Page is unloading');
      if (videoStream) {
        videoStream.getTracks().forEach((track) => track.stop());
        setGlobalState((prevState) => ({
          ...prevState,
          isExamEnded: false,
          isVideoFrozen: true,
          lastDetectedPlane: '',
          planes: {},
          viewList: [],
          viewDetectionOrder: [],
          reportModalOpened: false,
          receivedData: null,
          deviceId: '',
          selectedItem: 'Select your machine',
          pixelSpacingConfig: {},
          configMachine: {},
          isStart: false,
          inputDevices: [],
          selectedItemsMultidrop: [],
          optionValueDevice: 'USB',
          // add any other state keys you want to reset here
        }));
        setBool(true);
        setVideoMaskStream && setVideoMaskStream(null);
        setIsChecked(false);
        setSelectedPlansModal('');
        setSelectedPlansTag('');
        setShowDeviceModal(true);
        setIsInitialSetupComplete(false);
        setIsVideoBigDisplayOpen(false);
        setShowPatientModal(false);
        setSelectedRow(null);
        setExamDuration(realtimeExamDuration);
        setIsTimerRunning(false);
      }
    };

    window.addEventListener('beforeunload', handleBeforeUnload);

    return () => {
      console.log('Route or component unmounted:', location.pathname);
      if (videoStream) {
        videoStream.getTracks().forEach((track) => track.stop());
        setGlobalState((prevState) => ({
          ...prevState,
          isExamEnded: false,
          isVideoFrozen: true,
          lastDetectedPlane: '',
          planes: {},
          viewList: [],
          viewDetectionOrder: [],
          reportModalOpened: false,
          receivedData: null,
          deviceId: '',
          selectedItem: 'Select your machine',
          pixelSpacingConfig: {},
          configMachine: {},
          isStart: false,
          inputDevices: [],
          selectedItemsMultidrop: [],
          optionValueDevice: 'USB',
          // add any other state keys you want to reset here
        }));
        setBool(true);
        setVideoMaskStream && setVideoMaskStream(null);
        setIsChecked(false);
        setSelectedPlansModal('');
        setSelectedPlansTag('');
        setShowDeviceModal(true);
        setIsInitialSetupComplete(false);
        setIsVideoBigDisplayOpen(false);
        setShowPatientModal(false);
        setSelectedRow(null);
        setExamDuration(realtimeExamDuration);
        setIsTimerRunning(false);
      }
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, [location.pathname, videoStream]);
  useEffect(() => {
    if (sessionEnded) {
      handleFinishReport();
      setSessionEnded(false);
    }
  }, [sessionEnded]);
  useEffect(() => {
    if (!uid || data?.data?.report?.study?.is_locked) {
      navigate(-1);
    }
  }, [uid, navigate, data]);
  useEffect(() => {
    if (data) {
      setGlobalState((prevState) => ({
        ...prevState,
        patient: data?.data?.patient_info,
        doctorName:
          data?.data?.current_study_info?.user?.first_name +
          ' ' +
          data?.data?.current_study_info?.user?.last_name,
        examDate: data?.data?.current_study_info?.study_date,
      }));
    }
  }, [data, setGlobalState]);
  const handleFinishReport = async () => {
    const result = await apiClient.post(`/lockStudy/${uid}`);
    if (result?.status_code === 200) {
      messageI18n.success('realtime.studyLockedSuccess');
      navigate(`/exam/viewer?StudyInstanceUIDs=${uid}`);
    } else {
      console.error('Failed to lock study');
      messageI18n.error('realtime.lockFailed');
    }
  };
  const isInitialState = !globalState.deviceId && !globalState?.machineConfig;
  const isSessionActive = globalState.deviceId && globalState?.machineConfig;
  // const isLocked = data?.data?.current_study_info?.is_locked;
  //     console.log('Checking if study is locked:', isLocked);

  useEffect(() => {
    if (!data) {
      return;
    }

    // The check you want to perform
    // console.log('Checking if study is locked:', data);
    const isLocked = data?.data?.current_study_info?.is_locked;

    if (isLocked === true) {
      // Optional: Show a message to the user before redirecting
      messageI18n.warning('realtime.studyLockedCannotView');

      // 3. Redirect to the previous page
      navigate(-1); // -1 is the equivalent of the browser's back button
    }

    // The effect depends on the 'data' and 'navigate' objects
  }, [data, navigate]);
  const setDeviceIdCallback = useCallback(
    (value) => {
      setGlobalState((prevState) => ({
        ...prevState,
        deviceId: value,
      }));
    },
    [setGlobalState]
  );

  const setInputDevicesCallback = useCallback(
    (value) => {
      setGlobalState((prevState) => ({
        ...prevState,
        inputDevices: value,
      }));
    },
    [setGlobalState]
  );
  return (
    <>
      {isLoading || data?.data?.current_study_info?.is_locked ? (
        <div className="fixed inset-0 z-[100] flex h-full w-full flex-col items-center justify-center bg-white">
          <div className="loader">
            <Icon name={'deepechoLogo2'} />
          </div>
        </div>
      ) : (
        <div
          className={`relative mx-auto flex h-full flex-col bg-slate-50 dark:bg-gray-900 font-sans`}
        >
          {/* Hidden canvas */}
          <canvas ref={processingCanvasRef} style={{ display: 'none' }} />

          {/* MODALS with all props restored */}
          <StepperFeedRealtime
            setShowDeviceModal={setShowDeviceModal}
            showDeviceModal={showDeviceModal}
            startVideoStream={startVideoStream}
            mediaTypeSwitcher={mediaTypeSwitcher}
            globalState={globalState}
            setGlobalState={setGlobalState}
            inputDevices={globalState.inputDevices}
            api={API}
            token={user?.access_token}
            videoStream={videoStream}
            setVideoStream={setVideoStream}
            handleNext={() => {
              setShowDeviceModal(false);
              setIsInitialSetupComplete(true);
              setGlobalState((prevState) => ({
                ...prevState,
                isVideoFrozen: false,
                isStart: true,
              }));
            }}
            setDeviceId={setDeviceIdCallback}
            setInputDevices={setInputDevicesCallback}
          />
          <SelectView
            selectedPlan={selectedPlansModal}
            setSelectedPlansModal={setSelectedPlansModal}
            tag={selectedPlansTag}
            globalState={globalState}
            setGlobalState={setGlobalState}
            studyUID={uid}
          />
          <ReportModal
            globalState={globalState}
            setGlobalState={setGlobalState}
            planes={planes}
            studyUID={uid}
          />

          {/* MAIN CONTENT AREA */}
          <div className="flex h-full w-full flex-col p-6 bg-card-color-200 dark:bg-gray-900">
            {/* ======================================================================= */}
            {/* 1. Header with ALL buttons from original code restored and styled       */}
            {/* ======================================================================= */}
            <div className="flex w-full items-center justify-between">
              <div className="flex items-center space-x-4">
                <h1 className="text-2xl font-bold text-gray-900 dark:text-white">
                  Realtime Examination
                  {globalState?.patient?.patient_name && (
                    <span className="ml-2 font-semibold text-blue-600 dark:text-blue-400">
                      · {globalState.patient.patient_name}
                    </span>
                  )}
                </h1>
                <div
                  className={`inline-flex items-center gap-2 rounded-full px-4 py-1.5 text-sm font-medium border shadow-sm ${isSessionActive &&
                    !globalState.isExamEnded &&
                    !globalState.isVideoFrozen
                    ? 'bg-green-50 dark:bg-green-900/30 text-green-700 dark:text-green-400 border-green-200 dark:border-green-800'
                    : isSessionActive &&
                      !globalState.isExamEnded &&
                      globalState.isVideoFrozen
                      ? 'bg-yellow-50 dark:bg-yellow-900/30 text-yellow-700 dark:text-yellow-400 border-yellow-200 dark:border-yellow-800'
                      : globalState.isExamEnded
                        ? 'bg-gray-50 dark:bg-gray-800 text-gray-700 dark:text-gray-400 border-gray-200 dark:border-gray-700'
                        : 'bg-slate-50 dark:bg-gray-800 text-slate-600 dark:text-gray-400 border-slate-200 dark:border-gray-700'
                    }`}
                >
                  <div
                    className={`w-2 h-2 rounded-full ${isSessionActive &&
                      !globalState.isExamEnded &&
                      !globalState.isVideoFrozen
                      ? 'bg-green-500 animate-pulse'
                      : isSessionActive &&
                        !globalState.isExamEnded &&
                        globalState.isVideoFrozen
                        ? 'bg-yellow-500'
                        : 'bg-gray-400'
                      }`}
                  ></div>
                  <span>
                    {globalState.isExamEnded
                      ? 'Ended'
                      : isSessionActive
                        ? globalState.isVideoFrozen
                          ? 'Paused'
                          : 'Active'
                        : 'Not Started'}
                  </span>
                </div>
              </div>
              <div className="flex items-center space-x-2">
                {isInitialState &&
                  !globalState.isExamEnded &&
                  globalState?.isConnected && (
                    <Button
                      variant="primary"
                      size="sm"
                      className="px-5 font-semibold"
                      onClick={() => setShowDeviceModal(true)}
                    >
                      Start Examination
                    </Button>
                  )}

                {isSessionActive &&
                  !globalState.isExamEnded &&
                  globalState?.isConnected && (
                    <Button
                      variant="dark"
                      size="sm"
                      className="px-5 font-semibold"
                      onClick={handlePauseResume}
                    >
                      {!globalState.isVideoFrozen ? (
                        <>
                          <FaPause className="mr-2" />
                          Pause
                        </>
                      ) : (
                        <>
                          <FaPlay className="mr-2" />
                          Resume
                        </>
                      )}
                    </Button>
                  )}

                {isSessionActive &&
                  !globalState.isExamEnded &&
                  globalState?.isConnected && (
                    <Button
                      variant="destructive"
                      size="sm"
                      className="px-5 font-semibold"
                      onClick={() => {
                        setGlobalState((prevState) => ({
                          ...prevState,
                          isExamEnded: true,
                          isVideoFrozen: true,
                          isStart: false,
                        }));
                        if (videoStream) {
                          videoStream
                            .getTracks()
                            .forEach((track) => track.stop());
                        }
                        setIsTimerRunning(false);
                        setExamDuration(realtimeExamDuration);
                      }}
                    >
                      <FaHourglassEnd className="mr-2" /> End Session
                    </Button>
                  )}

                {/* Post-exam buttons - Show after exam has ended */}
                {isSessionActive && globalState.isExamEnded && (
                  <>
                    {/* --- Button 2: Home --- */}
                    <Button
                      variant="dark"
                      size="sm"
                      className="px-5 font-semibold"
                      onClick={() => navigate('/home')}
                      disabled={isPixelSpacingCalcul}
                    >
                      <MdOutlineDashboard className="mr-2" /> Home
                    </Button>

                    {/* --- Button 3: AI Accelerate --- */}
                    <Button
                      variant="dark"
                      size="sm"
                      className="px-5 font-semibold"
                      onClick={() => {
                        if (!isPixelSpacingCalcul) {
                          navigate(`/exam/viewer?StudyInstanceUIDs=${uid}`);
                        }
                      }}
                      disabled={isPixelSpacingCalcul}
                    >
                      <IoIosFlash size={18} className="mr-2" /> AI Accelerate
                    </Button>
                  </>
                )}
              </div>
            </div>

            {/* ======================================================================= */}
            {/* 2. Progress Bar - Polished and beautiful                                */}
            {/* ======================================================================= */}
            <div className="my-4 rounded-lg bg-white dark:bg-gray-800 border border-slate-200 dark:border-gray-700 p-5 shadow-sm">
              <div className="flex justify-between items-center mb-3">
                <div className="flex items-center gap-3">
                  <div className="flex items-center gap-2">
                    <div className="w-2 h-2 bg-blue-500 dark:bg-blue-400 rounded-full"></div>
                    <span className="text-sm font-semibold text-gray-800 dark:text-white uppercase tracking-wide">
                      Scan Progress
                    </span>
                  </div>
                  {!globalState.isExamEnded &&
                    isSessionActive &&
                    !globalState.isVideoFrozen && (
                      <div className="flex items-center gap-2 px-2 py-1 rounded-full bg-blue-50 dark:bg-blue-900/30">
                        <FaSpinner
                          size={12}
                          className="animate-spin text-blue-600 dark:text-blue-400"
                        />
                        <span className="text-xs font-medium text-blue-600 dark:text-blue-400">
                          Scanning...
                        </span>
                      </div>
                    )}
                </div>
                <div className="flex items-center gap-2">
                  <span className="text-2xl font-bold text-blue-600 dark:text-blue-400">
                    {planesWithFrameCount}
                  </span>
                  <span className="text-sm text-gray-500 dark:text-gray-400">
                    / 23 Views
                  </span>
                </div>
              </div>
              <div className="w-full bg-slate-100 dark:bg-gray-700 rounded-full h-2 overflow-hidden shadow-inner">
                <div
                  className="bg-gradient-to-r from-blue-500 to-blue-600 dark:from-blue-500 dark:to-blue-600 h-full rounded-full transition-all duration-500 ease-out shadow-sm"
                  style={{ width: `${(planesWithFrameCount / 23) * 100}%` }}
                ></div>
              </div>
              <div className="mt-2 text-xs text-gray-500 dark:text-gray-400 text-right">
                {Math.round((planesWithFrameCount / 23) * 100)}% Complete
              </div>
            </div>

            {/* ======================================================================= */}
            {/* 3. Hidden Video/Instructions Section - Preserved from old code          */}
            {/* ======================================================================= */}
            {globalState?.isExamEnded == false && (
              <div className="lg:flex grid grid-cols-1 h-0 w-full gap-4 lg:gap-0 lg:space-x-4">
                <Card className="w-full hidden">
                  <div className="flex h-full w-full space-x-5">
                    <div className="w-[65%] xl:w-[50%]">
                      <VideoDisplay
                        isVideoLoading={isVideoLoading}
                        setModalOpen={setIsVideoBigDisplayOpen}
                        globalState={globalState}
                        handleVideoClick={handleVideoClick}
                        videoRef={videoRef}
                        webrtcVideoRef={webrtcVideoRef}
                        isInferencing={isInferencing}
                        setGlobalState={setGlobalState}
                        processedVideoRef={processedVideoRef}
                        canvasRef={canvasRef}
                      />
                      <VideoModal
                        isOpen={isVideoBigDisplayOpen}
                        onClose={() => setIsVideoBigDisplayOpen(false)}
                        videoStream={videoStream}
                        viseaRtcStream={videoMaskStream}
                        displayDimensions={DISPLAY_DIMENSIONS}
                        handleVideoClick={handleVideoClick}
                        isInferencing={isInferencing}
                        modalCanvasVideoRef={modalCanvasVideoRef}
                        globalState={globalState}
                        handleChange={handleChange}
                        isChecked={isChecked}
                      />
                    </div>
                    <div className="mt-1 flex w-[35%] space-x-2">
                      <div className="flex items-center justify-start">
                        <RatingBar align={'V'} globalState={globalState} />
                      </div>
                      <div className="flex w-full flex-col items-center justify-center space-y-2 text-xs font-medium text-slate-600 dark:text-gray-400">
                        <div className="inline-flex w-full space-x-2">
                          <PiInfo
                            size={22}
                            className="text-blue-500 dark:text-blue-400"
                          />
                          <span>
                            Ensure proper gel application for clear imaging
                          </span>
                        </div>
                        <div className="inline-flex w-full space-x-2">
                          <PiInfo
                            size={26}
                            className="text-blue-500 dark:text-blue-400"
                          />
                          <span>
                            Ensure steady probe movement to capture accurate
                            scans.
                          </span>
                        </div>
                        <div className="inline-flex w-full space-x-2">
                          <PiInfo
                            size={22}
                            className="text-blue-500 dark:text-blue-400"
                          />
                          <span>
                            Adjust depth and focus for optimal image clarity.
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </Card>
                <LastDetectedPlanes
                  globalState={globalState}
                  lastDetectedPlane={globalState?.lastDetectedPlane}
                  predictionHistory={predictionHistory}
                  skeletonCount={skeletonCount}
                />
                {/* Debug: Direct segmentation drawing (bypasses view logic) */}
                {/* <DebugSegmentations /> */}
              </div>
            )}

            {/* ======================================================================= */}
            {/* 4. The Grid - PERFECTED VIEW CARDS with creative enhancements           */}
            {/* ======================================================================= */}
            <div className="flex-grow overflow-y-auto custom-scrollbar -mr-4 pr-4 pt-4">
              <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6 2xl:grid-cols-8">
                {planes
                  .map((plane, index) => {
                    const isLoadingPlane =
                      isPixelSpacingCalcul &&
                      globalState?.planes?.[plane?.tag]?.predictionHistory &&
                      [
                        'Fetal Abdominal Standard Plane',
                        'Transthalamic View',
                        'Transcerebellar View',
                        'Femur (Femoral) Plane',
                      ].includes(plane?.label);
                    const hasHistory =
                      !!globalState?.planes?.[plane?.tag]?.predictionHistory;
                    const foundImageSrc = hasHistory
                      ? globalState?.planes?.[plane?.tag]
                        ?.predictionHistory?.[0]?.imagePredictedPlane
                      : null;

                    return (
                      <div
                        key={index}
                        className={`group relative aspect-square overflow-hidden rounded-lg border transition-all duration-200 ${hasHistory
                          ? 'bg-white dark:bg-gray-800 border-slate-200 dark:border-gray-700 shadow-sm'
                          : 'bg-slate-50 dark:bg-gray-800/50 border-slate-300 dark:border-gray-600'
                          } ${hasHistory && !isLoadingPlane
                            ? 'cursor-pointer hover:shadow-md hover:border-blue-400 dark:hover:border-blue-500 hover:-translate-y-0.5'
                            : 'cursor-not-allowed'
                          }`}
                        onClick={() => {
                          if (hasHistory && !isLoadingPlane) {
                            setSelectedPlansModal(plane?.label);
                            setSelectedPlansTag(plane?.tag);
                          }
                        }}
                      >
                        {/* STATE: PENDING (NOT FOUND) */}
                        <div
                          className={`absolute inset-0 flex flex-col items-center justify-between p-2 sm:p-3 text-center transition-opacity duration-500 ${hasHistory ? 'opacity-0 pointer-events-none' : 'opacity-100'}`}
                        >
                          {/* Pending Indicator - Top Right */}
                          <div className="absolute top-2 right-2 w-2 h-2 rounded-full bg-slate-400 dark:bg-gray-500 shadow-sm"></div>

                          <div className="flex items-center justify-center w-full h-full">
                            <img
                              src={plane.imgPlane}
                              className="max-w-[90%] max-h-[90%] object-contain opacity-40 dark:opacity-30"
                              alt={plane.label}
                            />
                          </div>
                          <div className="w-full flex-shrink-0">
                            <p className="text-xs font-semibold text-slate-700 dark:text-gray-300 line-clamp-2 px-1">
                              {plane.label}
                            </p>
                          </div>
                        </div>

                        {/* STATE: PLANE FOUND (ACTIVATED) */}
                        {hasHistory && (
                          <div
                            className={`absolute inset-0 transition-opacity duration-500 ${hasHistory ? 'opacity-100' : 'opacity-0'}`}
                          >
                            <img
                              src={foundImageSrc}
                              className="h-full w-full object-cover transition-transform duration-300 ease-in-out group-hover:scale-105"
                              alt={plane.label}
                            />
                            <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/30 to-transparent"></div>
                            <div className="absolute inset-0 p-2 sm:p-3 flex flex-col justify-between">
                              <div className="flex justify-between items-start gap-1 sm:gap-2">
                                <span className="font-semibold text-white text-xs sm:text-xs leading-tight drop-shadow-lg flex-1 line-clamp-2">
                                  {plane.label}
                                </span>
                                <div className="flex items-center gap-0.5 sm:gap-1 rounded-full bg-blue-500/90 dark:bg-blue-600/90 backdrop-blur-sm px-1.5 sm:px-2 py-0.5 sm:py-1 text-xs font-bold text-white shadow-lg flex-shrink-0">
                                  <TfiLayers size={9} />
                                  <span className="text-xs">
                                    {
                                      globalState?.planes?.[plane?.tag]
                                        ?.predictionHistory?.length
                                    }
                                  </span>
                                </div>
                              </div>
                              <div className="flex items-center justify-between">
                                <div className="inline-flex items-center gap-1 px-1.5 sm:px-2 py-0.5 sm:py-1 rounded-full bg-green-500/90 dark:bg-green-600/90 backdrop-blur-sm shadow-lg">
                                  <div className="w-1.5 h-1.5 bg-white rounded-full animate-pulse"></div>
                                  <span className="text-xs font-semibold text-white">
                                    Detected
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                        )}

                        {/* LOADING OVERLAY */}
                        {isLoadingPlane && (
                          <div className="absolute inset-0 z-20 flex flex-col items-center justify-center gap-2 bg-white/95 dark:bg-gray-900/95 backdrop-blur-sm border-2 border-blue-400 dark:border-blue-500">
                            <div className="relative">
                              <div className="absolute inset-0 blur-lg bg-blue-500 opacity-50 rounded-full"></div>
                              <AiOutlineLoading
                                className="relative animate-spin text-blue-600 dark:text-blue-400"
                                size={24}
                              />
                            </div>
                            <span className="text-xs font-semibold text-gray-700 dark:text-gray-300">
                              Processing...
                            </span>
                          </div>
                        )}
                      </div>
                    );
                  })}
              </div>
            </div>

            {/* ======================================================================= */}
            {/* 5. Footer Connection Status                                             */}
            {/* ======================================================================= */}
            {!globalState.isExamEnded && (
              <div className="flex-shrink-0 pt-6 flex justify-center">
                {globalState?.isConnected ? (
                  <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-green-50 dark:bg-green-900/20 border border-green-200 dark:border-green-800">
                    <div className="relative flex h-2.5 w-2.5">
                      <div className="animate-ping absolute inline-flex h-full w-full rounded-full bg-green-400 opacity-75"></div>
                      <div className="relative inline-flex rounded-full h-2.5 w-2.5 bg-green-500"></div>
                    </div>
                    <span className="text-sm font-medium text-green-700 dark:text-green-400">
                      Secure Connection
                    </span>
                  </div>
                ) : (
                  <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-800">
                    <div className="h-2.5 w-2.5 rounded-full bg-red-500 animate-pulse"></div>
                    <span className="text-sm font-medium text-red-700 dark:text-red-400">
                      Connection Lost
                    </span>
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
      )}
    </>
  );
};

const RealTimeInferencingV3WithProvider: React.FC = () => {
  return (
    <RealtimeGlobalStateProvider>
      <RealTimeInferencingV3 />
    </RealtimeGlobalStateProvider>
  );
};

export default RealTimeInferencingV3WithProvider;
